var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoRadioEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,50c0,8.3-2.9,15.4-8.8,21.2S58.3,80,50,80c-8.3,0-15.4-2.9-21.2-8.8S20,58.3,20,50s2.9-15.4,8.8-21.2S41.7,20,50,20 c8.3,0,15.4,2.9,21.2,8.8S80,41.7,80,50z M77.5,50c0-7.6-2.7-14.1-8.1-19.5S57.6,22.5,50,22.5c-7.6,0-14.1,2.7-19.5,8.1 S22.5,42.4,22.5,50s2.7,14.1,8.1,19.5s11.9,8.1,19.5,8.1c7.6,0,14.1-2.7,19.5-8.1S77.5,57.6,77.5,50z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRadioEmpty);
export default __webpack_public_path__ + "static/media/ico_radio-empty.6f5d2bd0e7915a5b4d9ae247711f05cc.svg";
export { ForwardRef as ReactComponent };